import Requester from '@cobliteam/api-lib/src/request/Requester';
import Environment from '@cobliteam/react-environments';
import { DefaultChatTransport } from 'ai';
import type { AgentNames, Component, ResourceId, Source } from '../types';

const environment = Environment.getInstance().getEnvironment();
const MASTRA_API_URL = environment.mastraApi;
const requester = new Requester({ host: environment.herbieApiHost });

export type ChatTransportProps = {
  agentName: AgentNames;
  threadId?: string;
  resourceId: ResourceId;
  source: Source;
  component: Component;
  url: string;
};

export const chatTransport = ({ agentName, threadId, resourceId, source, component, url }: ChatTransportProps) => {
  if (!threadId) {
    throw new Error('Thread ID is required');
  }

  if (!resourceId) {
    throw new Error('Resource ID is required');
  }

  if (!agentName) {
    throw new Error('Agent name is required');
  }

  return new DefaultChatTransport({
    api: `${MASTRA_API_URL}/api/v1/chat/${agentName}`,
    prepareSendMessagesRequest: (options) => {
      return {
        body: {
          ...options,
          threadId,
          resourceId,
          source,
          component,
          url,
          memory: {
            thread: threadId,
            resource: resourceId,
          },
        },
      };
    },
    headers: async () => {
      const accessToken = await requester.getValidToken();
      return { Authorization: `Bearer ${accessToken}` };
    },
  });
};
